//@ts-nocheck
import React, { useEffect } from 'react';
import styled from "styled-components";
import * as d3 from "d3";
import { sankey, sankeyLeft } from "d3-sankey";
import { create as createLinks } from "./elements/links";
import { create as createNodes, moveNodeTo } from "./elements/nodes";
import { exportECRChart, filterECRHeading, color } from "./elements/helpers";
import { Heading3, ReportText } from '../../Common/SharedStyledComponents';
import "./EarlyCareerReportSankey.css";


const EarlyCareerReportSankey = ({
     sankeyData,
     parentWidth,
     EarlyCareerReportState,
     report_display_id,
     currentDateTime,
     university,
     start_year,
     end_year,
     vintage
 }) => {
    //console.log(sankeyData);
    const edgeColor = "path";
    const width = parentWidth || 900;
    const height = 400;
    const margins = { top: 50, left: 50, bottom: 10, right: 150 };
    //const margins = [50, 50];

    let sourceData = {};

    const getInitialData = (sankeyData) => {
        let nodes = [{ "name": "assistant-1" }];
        const years = [...new Set(sankeyData.map(e => { return e.t_emp; }))];

        years.forEach(year => {
            if (year > 1) {
                nodes.push({ "name": "assistant-" + year });
                nodes.push({ "name": "promoted-" + year });
                nodes.push({ "name": "unobserved-" + year });
            }
        })



        let links = [];
        sankeyData.forEach(element => {
            if (element.path_source != null && element.path_target != null) {
                links.push({
                    "source": element.path_source + "-" + (element.t_emp+ - 1),
                    "target": element.path_target + "-" + element.t_emp,
                    "value": element.count_emp_number
                })
            }
            else {
                //console.log("ignore the nulls");
            }
        })
        sourceData["nodes"] = nodes;
        sourceData["links"] = links;
        sourceData["unites"] = "";

        const { units, nodes, links } = sourceData;
        const initData = {
            nodes: nodes.map((node) => Object.assign({}, node)),
            links: links.map((link) => Object.assign({}, link)),
            units
        }
        return initData;
    };

    const sankeyGenerator = sankey()
        .nodeId((d) => d.name)
        .nodeAlign(sankeyLeft)
        .nodeWidth(15)
        .nodePadding(30)
        .nodeSort(function (a, b) {
            return d3.ascending(a.name, b.name);
        })
        .extent([[margins.left, margins.top], [width - margins.left - margins.right, height - margins.top - margins.bottom]]);

    const getChart = () => {
        const { units } = sourceData;
        const data = sankeyGenerator(getInitialData(sankeyData));

        const container = d3.create("svg").attr("id", "ecr-sankey").attr("viewBox", [0, 0, width, height]);

        createLinks({ container, data, edgeColor, units, sankeyGenerator });
        createNodes({ container, data, units, width, height });

        return { node: container.node(), data };
    };

    const appendChart = () => {
        const container = document.getElementById("Sankey");
        container.style.width = `${width}px`;
        container.style.height = `${height}px`;

        const { node, data } = getChart();
        container.appendChild(node);

        if (node != null) {

            //adding axis
            //TODO: make the end year dynamic
            const years = [...new Set(sankeyData.map(e => e.t_emp))].sort(d3.ascending);
            let scale = d3.scalePoint().domain(years).rangeRound([0, 650]);
            let axis = d3.axisBottom(scale).tickSize(0).tickPadding(10).tickFormat(d3.format("d")).tickValues(years);

            d3.select('#ecr-sankey g')
                .append('g')
                .attr("font-size", "10px")
                .attr("transform", "translate(" + margins.left + "," + (height - 50) + ")")
                .call(axis);

            //Add Axis Labels
            d3.select('#ecr-sankey g')
                .append('g')
                .append("text")
                .attr("x", width / 2 - margins.left - 50)
                .attr("y", height - 5)
                .classed("sankey-axis-label", true)
                .style("fill", "black")
                .attr("stroke-width", "0.1")
                .text("Data Year");

            //adding legend
            var legend = d3.select('#ecr-sankey')
                .append('g')
                .attr('class', 'ecr_legend')
                .attr('transform', 'translate(' + (width - 300) + ', ' + (height - 110) + ')');

            //var subgroups = ["Assistant Professor", "Promoted", "Unobserved"];
            var subgroups = [{ name: "assistant-0", longName: "Assistant Professor" }, { name: "promoted-0", longName: "Promoted" }, { name: "unobserved-0", longName: "Unobserved" }];

            legend.selectAll('rect')
                .data(subgroups)
                .enter()
                .append('rect')
                .attr('x', 0)
                .attr('y', function (d, i) {
                    return i * 18;
                })
                .attr('width', 12)
                .attr('height', 12)
                .attr('stroke', 'black')
                .attr('fill', function (d, i) {
                    return color(d);
                });

            legend.selectAll('text')
                .data(subgroups)
                .enter()
                .append('text')
                .text(d => d.longName)
                .attr('x', 18)
                .attr('y', function (d, i) {
                    return i * 18;
                })
                .attr('text-anchor', 'start')
                .attr('alignment-baseline', 'hanging')
                .attr('font-family', 'Calibri');
        }

        return data;
    };

    useEffect(() => {
        d3.select("#Sankey svg").remove();

        if (sankeyData && sankeyData.length > 0) {
            try {
                const data = appendChart();
                exportECRChart("#Sankey", "sankey.png", EarlyCareerReportState, report_display_id, currentDateTime, "no", vintage)
            }
            catch (err) {

            }
        }


    }, [sankeyData])

    const subHeading = filterECRHeading(EarlyCareerReportState.EarlyCareerReportFilterSavedValues, EarlyCareerReportState.Suborgs);

    return (
        <div className="ChartComponent">
            <div id="Sankey_ForExport">
                <Heading3 bold italic>Population of "Data Year" Cohorts</Heading3>
                <Heading3 italic>{subHeading}</Heading3>
                <div id="Sankey"></div>
                {sankeyData?.length == 0 && <p className="no_data_text">Due to the small number of results and the potential for disclosure of personal information, this chart cannot be displayed. Please select a larger group.</p>}
                <ReportText>
                    This chart shows the population of the “Data Year” cohorts used in this report and the job ranks of faculty in each cohort. The cohorts are based on faculty members’ appearance in the IRIS-UMETRICS dataset, which contains information on researchers named on funded grants. “Data Year 1,” for example, consists of all faculty members during the first year they are observed in the dataset, regardless of the calendar year. “Data Year 2” contains all faculty members observed for two years in the dataset, and so on.
                </ReportText>
                <ReportText>
                    The “promoted” category includes all ranks above “assistant professor.” Faculty members who move into the “unobserved” category are those for whom we observe no additional research grant employment, whether due to ceasing grant employment, leaving the {university}, or reaching the most recent year of data collection. The data used to build the cohorts are from {start_year} to {end_year}.
                </ReportText>
            </div>
            <a className="export" onClick={() => exportECRChart("#Sankey_ForExport", "sankey.png", EarlyCareerReportState, report_display_id, currentDateTime, "yes", vintage)}><i className="fa fas fa-download ecr_export"></i>Export Chart</a>
        </div>
    );
}

/**
 * Styled div to shrink graph titles
 * */
export const TitleDiv = styled.div`
    width: 75%;
    margin-inline: auto;
`;

export default EarlyCareerReportSankey;